var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyAssetsTabIcon = function SvgEmptyAssetsTabIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none",
    viewBox: "0 0 52 52"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    stroke: "#3D4355",
    d: "M.5 6.794C.5 6.08 1.08 5.5 1.794 5.5h18.972c.958 0 1.734.776 1.734 1.734a2.734 2.734 0 0 0 2.734 2.734h11.795a8.47 8.47 0 0 1 8.471 8.47V38.03a8.47 8.47 0 0 1-8.47 8.471H2A1.5 1.5 0 0 1 .5 45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#3D4355",
    d: "M10.999 17.498a1.5 1.5 0 0 1 1.413-.998H37.51c7.518 0 13.014 7.095 11.135 14.374L44.613 46.5H2.832a1.5 1.5 0 0 1-1.414-2.002z"
  })));
};
export default SvgEmptyAssetsTabIcon;